module.exports = {"TXTWCL_Close":{"id":"TXTWCL_Close","defaultMessage":"Schließen","track":"Close"}}